import { connect } from "react-redux";
import { closeModal } from "actions/modals";
import { createProposalWithDeal } from "actions/proposal";
import { push } from "connected-react-router";

import ProposalModal from "./ProposalModal";

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (proposal) =>
    dispatch(createProposalWithDeal(proposal)).then((res) => {
      dispatch(closeModal("ProposalModal"));

      return dispatch(push(`/deals/${res.value.proposal.deal.id}`));
    }),
});

export default connect(null, mapDispatchToProps)(ProposalModal);
